<template>
  <el-drawer title="WoYou工资帮助"
             :visible.sync="drawerHelpVisible"
             direction="rtl"
             size="400px"
             :wrapperClosable="false"
             :close-on-press-escape="false"
             @close="drawerHelpVisibleClose"
             overflow:auto
             class="helpBox">
    <!-- <iframe
      src="https://nwoyou.rayqee.com/help.pdf"
      style="width: 100%; height: 100%"
    ></iframe> -->
    <div class="outside">
      <el-input placeholder="输入关键词搜索答案"
                prefix-icon="el-icon-search"
                v-model="keyWord"
                @change="search">
      </el-input>
      <div class="box">
        <div class="page1"
             v-if="!secondaryClass && searchFlag == false">
          <ul>
            <li v-for="item in data"
                :key="item.id"
                @click="change(item, true)">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="page2"
             v-if="secondaryClass && searchFlag == false">
          <div>
            <div class="back"
                 @click="back">
              <i class="el-icon-arrow-left"></i><span>{{ backName }}</span>
            </div>
            <div class="secondClass"
                 v-if="childClassList && childClassList.length > 0">
              <div class="secondClass-left">
                <div @click="changeSecond(item), (activeNum = i)"
                     v-for="(item, i) in childClassList"
                     :key="item.id"
                     :class="['classItem', { active: activeNum == i }]">
                  {{ item.name }}
                </div>
              </div>
              <div class="secondClass-right"
                   v-if="residueClassList && residueClassList.length > 0">
                <el-dropdown @command="handleCommand"
                             trigger="click">
                  <span class="el-dropdown-link">
                    <i class="el-icon-s-grid"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="i"
                                      v-for="(item, i) in residueClassList"
                                      :key="item.id">{{ item.name }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <ul>
              <li v-for="item in infoData"
                  :key="item.id"
                  @click="getDetail(item)">
                {{ item.title }}
              </li>
            </ul>
          </div>
        </div>
        <div class="page1"
             v-if="searchFlag">
          <div class="tip">
            共找到信息<span style="color: red">{{ searchData.length }}</span>条
            <el-button @click="delResult"
                       style="margin-left: 10px; color: red"
                       type="text"
                       icon="el-icon-delete">清除结果</el-button>
          </div>
          <ul>
            <li v-for="item in searchData"
                :key="item.id"
                @click="getDetail(item)">
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
      <el-dialog title="WoYou工资帮助"
                 append-to-body
                 :visible.sync="dialogVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="1150px">
        <div class="detail-box">
          <div class="title">{{ detail.title }}</div>
          <div class="time">
            {{ detail.createDate && detail.createDate.slice(5, 10) }}
          </div>
          <richTextAndPreview :detail="content" />
        </div>
      </el-dialog>
    </div>
  </el-drawer>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import richTextAndPreview from "./richTextAndPreview";

export default {
  components: { ElImageViewer, richTextAndPreview },
  props: {
    visible: Boolean,
  },
  data () {
    return {
      drawerHelpVisible: false,
      dialogImageUrl: "",
      dialogVisible: false,
      secondaryClass: false,
      keyWord: "",
      data: [],
      infoData: [],
      childClassList: [],
      backName: "",
      activeNum: 0,
      residueClassList: [],
      detail: {},
      searchFlag: false,
      searchData: [],
      content: "",
    };
  },
  methods: {
    delResult () {
      this.searchData = [];
      this.keyWord = "";
      this.searchFlag = false;
    },
    search () {
      let sendData = {
        keyWord: this.keyWord,
      };
      this.$api.manage.HelpInfoList(sendData).then((res) => {
        if (res.error === false) {
          this.searchData = res.data;
          this.searchFlag = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //获取详情
    getDetail (row) {
      let sendData = {
        id: row.id,
      };
      this.$api.manage.HelpInfoDetail(sendData).then((res) => {
        if (res.error === false) {
          this.detail = res.data;
          this.content = res.data.content;
          this.dialogVisible = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //点击
    change (item, flag) {
      this.childClassList = [];
      //判断是不是第一级
      if (flag) {
        this.backName = item.name;
      }
      if (item.haveInfo) {
        this.getPage(item);
      } else if (item.childList.length > 0) {
        this.getPage(item.childList[0]);
        this.secondaryClass = true;
        //整理二级分类
        if (item.childList <= 3) {
          this.childClassList = item.childList;
        } else {
          this.childClassList = item.childList.slice(0, 3);
          this.residueClassList = item.childList.slice(3);
        }
      }
    },
    //改变二级分类
    changeSecond (item) {
      this.getPage(item);
    },
    getPage (row) {
      let sendData = {
        keyWord: this.keyWord,
        helpClassId: row.id,
      };
      this.$api.manage.HelpInfoList(sendData).then((res) => {
        if (res.error === false) {
          this.infoData = res.data;
          this.secondaryClass = true;

        } else {
          this.$message.error(res.msg);
        }
      });
    },
    back () {
      this.activeNum = 0;
      this.secondaryClass = !this.secondaryClass;
    },
    //获取分类列表
    HelpClassList () {
      this.$api.manage.HelpClassList().then((res) => {
        if (res.error === false) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 点击切换二级分类
    handleCommand (index) {
      console.log(index);
      this.activeNum = 0;
      this.getPage(this.residueClassList[index]);
      let excess = this.childClassList[this.childClassList.length - 1];
      this.childClassList.splice(this.childClassList.length - 1);
      this.childClassList.unshift(this.residueClassList[index]);
      this.residueClassList.splice(index, 1);
      this.residueClassList.push(excess);
    },
    drawerHelpVisibleClose () {
      this.$emit("close");
    },
  },
  watch: {
    visible (val) {
      this.drawerHelpVisible = val;
      if (val) {
        this.HelpClassList();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-dropdown {
  font-size: 20px;
  cursor: pointer;
}

.el-icon-refresh-left {
  //刷新
  font-size: 25px;
  margin-left: 160px;
  transform: translateY(8px);
}
.el-icon-tickets {
  font-size: 20px;
  margin-left: 40px;
  transform: translateY(3px);
  box-shadow: 0 2px 4px rgba(50, 50, 50, 0.2);
}
.detail-box {
  height: 480px;
  overflow: auto;
  margin-top: -15px;
  padding: 0 30px;

  .title {
    font-size: 20px;
    color: black;
    font-weight: 600;
  }
  .time {
    margin: 20px 0 20px 0;
    font-size: 12px;
  }
}
.outside {
  background-color: rgb(252, 249, 249);
  padding: 15px;
  height: 100%;
  overflow: auto;
  .back {
    padding-top: 15px;
    font-size: 16px;
    cursor: pointer;
    i {
      margin-right: 7px;
    }
  }
  .content {
    img {
      max-width: 100%;
    }
  }
  .secondClass {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .secondClass-left {
      display: flex;
      overflow: auto;
      width: 88%;
      padding: 15px 0 5px 0;

      &::-webkit-scrollbar {
        height: 8px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        // 规定背景的绘制区域 padding-box：背景被裁剪到内边距框
        background-clip: padding-box;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        border-radius: 4px;
        min-height: 28px;
      }
    }
    .secondClass-right {
      font-size: 20px;
    }
    .classItem {
      flex-shrink: 0;
      margin-right: 20px;
      padding-bottom: 5px;
      cursor: pointer;
    }
    .active {
      color: #4e89f7;
      border-bottom: 2px solid #4e89f7;
    }
  }

  li {
    margin-top: 15px;
    font-size: 15px;
    margin-left: 20px;
    list-style-type: disc;
    color: rgb(90, 92, 92);
    cursor: pointer;
  }
  li:hover {
    color: #4e89f7;
  }
}
.page1 {
  ul li::marker {
    font-size: 8px;
  }
  .tip {
    margin-top: 15px;
    font-size: 12px;
  }
}
.page2 {
  height: 100%;
  // ul {
  //   height: auto;
  //   max-height: 80vh;
  //   overflow: auto;
  // }
  ul li:first-child {
    padding-top: 0px;
  }
  ul li::marker {
    font-size: 8px;
  }
}
</style>

